import { NavItemAccessor } from '@billy/design-system'
import { TFunction } from 'i18next'

import { VatRateItem } from '../types/vatRateItem'

export const getRegionGroupAccessors = (t: TFunction): VatRateItem[] => [
  {
    id: 'local',
    accessor: NavItemAccessor.Header,
    children: t('external_invoices.vat_rates.group.local'),
    value: {
      displayData: {
        title: t('external_invoices.vat_rates.group.local'),
      },
    },
  },
  {
    id: 'eu',
    accessor: NavItemAccessor.Header,
    children: t('external_invoices.vat_rates.group.eu'),
    value: {
      displayData: {
        title: t('external_invoices.vat_rates.group.eu'),
      },
    },
  },
  {
    id: 'world',
    accessor: NavItemAccessor.Header,
    children: t('external_invoices.vat_rates.group.world'),
    value: {
      displayData: {
        title: t('external_invoices.vat_rates.group.world'),
      },
    },
  },
]
